import { ApiError } from "@/shared/api";

/**
 * 登录失败的对客文案(OEM W3 C-G)。
 *
 * 两个渠道码给固定人话,不直出后端 message(后端文案以后可能改,登录页这两句是拍板口径):
 *   - PARTNER_DOMAIN_MISMATCH:租户账号从别家渠道域名登录 —— **不回显正确域名**(防探出渠道域名清单);
 *   - PARTNER_SUSPENDED:所属渠道商停用 / 解约。
 * 其余照旧用 Error.message(后端 message 已是人话,httpClient 已统一脱敏)。
 */
export const PARTNER_LOGIN_ERROR_TEXT: Record<string, string> = {
  PARTNER_DOMAIN_MISMATCH: "请从贵司专属登录地址登录",
  PARTNER_SUSPENDED: "服务已暂停,请联系您的服务商",
};

export function loginErrorText(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    const fixed = PARTNER_LOGIN_ERROR_TEXT[err.errorCode];
    if (fixed) return fixed;
  }
  if (err instanceof Error) return err.message || fallback;
  return fallback;
}

// 1002:实现放 shared(渠道不存在页在 App 之外渲染,也要用);这里转出,登录页沿用本模块入口。
export { migratedLoginUrl } from "@/shared/lib/migratedLoginUrl";
